import { Decision } from '@/interfaces/decision';
import { DecisionResource, decisionResource } from '@/resources/decision.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł decyzji
 *
 * @export
 * @class DecisionModule
 * @extends {EntityModule<Decision, DecisionResource>}
 */
export class DecisionModule extends EntityModule<Decision, DecisionResource> {
  constructor() {
    super(decisionResource);

    this.state = {
      ...this.state,
      dateRanges: []
    } as any;

    this.mutations = {
      ...this.mutations,

      /**
       * Zapisuje dane
       *
       * @param {*} localState
       * @param {*} data
       */
      saveDates(localState: any, data: any): void {
        localState.dateRanges = data;
      }
    };

    this.actions = {
      ...this.actions,

      /**
       * Daty zapłaty
       */
      getDates: async (context: any, data: any): Promise<void> => {
        if (!data.documentId && !data.statusId) {
          return;
        }

        try {
          const response = await this.resource.getDates(data.documentId, data.statusId);
          context.commit('saveDates', response.dateRanges);
          // tslint:disable-next-line:no-empty
        } catch (e) {}
      }
    };
  }
}

export default new DecisionModule();
